import { openDB } from 'idb';
import * as Constants from '../../../config/Constants.ts'

const DB_NAME = 'chatbot_db';
const DB_VERSION = 2;

class ChatIDB {

    constructor() {
        this.db = this.initDB();
    }

    initDB = async () => {
        try {
            const idb = openDB(DB_NAME, DB_VERSION, {
                upgrade(db) {
                    if (!db.objectStoreNames.contains(`${Constants.REQ_CHATBOT_TAB_TYPE.SUPPORT}_messages`)) {
                        db.createObjectStore(`${Constants.REQ_CHATBOT_TAB_TYPE.SUPPORT}_messages`, { keyPath: 'timestamp' });
                    }
                },
            });
            return idb
        } catch (e) {
            console.log('[initDB] ---------- Error :: ' + e);
        }
    }

    addMessage = async (tab, message) =>{
        try {

            const db = await this.db;
            await db.put(`${tab}_messages`, {
                ...message,
                timestamp: message.chatid,
            });
            console.log(`[addMessage]  mesagge : ${JSON.stringify(message)} added to ${tab}_messages DB`)
        } catch (e) {
            console.log('[addMessage] ---------- Error :: ' + e);
        }
    }

    deleteMessage = async (tab, id) =>{
        try {
            const storeName = `${tab}_messages`;
            const db = await this.db;

            const tx = db.transaction(storeName, 'readwrite');
            const store = tx.objectStore(storeName);

            await store.delete(id);
            await tx.done;

            console.log(`[deleteMessage] Message ${id} deleted from ${storeName}`);
        } catch (e) {
            console.error(`[deleteMessage] Error deleting message ${id}:`, e);
        }
    };


    getAllMessages = async (tab) => {
        try {

            const db = await this.db;
            const tab_messages = await db.getAll(`${tab}_messages`);
            console.log(`[getAllMessages]  got : ${tab_messages.length} no of messages from ${tab}_messages DB`);
            return tab_messages;
        } catch (e) {
            console.log('[getAllMessages] ---------- Error :: ' + e);
        }

    }

    clearChatBotDatabase = async () => {
        try {
            const db = await this.db;

            const supportStore = `${Constants.REQ_CHATBOT_TAB_TYPE.SUPPORT}_messages`;

            const storesToClear = [supportStore].filter((storeName) => db.objectStoreNames.contains(storeName));

            if (storesToClear.length === 0) {
                console.warn('[clearChatBotDatabase] No matching object stores found to clear.');
                return;
            }

            const tx = db.transaction(storesToClear, 'readwrite');

            await Promise.all(
                storesToClear.map((storeName) => tx.objectStore(storeName).clear())
            );

            await tx.done;
            console.log('[clearChatBotDatabase] All chatbot history cleared.');
        } catch (e) {
            console.error('[clearChatBotDatabase] Error:', e);
        }
    };

    updateMessageData = async (chatid) =>{
        try {

            const db = await this.db;
            const storeName = `${Constants.REQ_CHATBOT_TAB_TYPE.SUPPORT}_messages`;
            const tx = db.transaction(storeName, 'readwrite');
            const store = tx.objectStore(storeName);

            if (store.length === 0) {
                console.warn('[updateMessageData] No matching object stores found to clear.');
                return;
            }

            const existing = await store.get(chatid);
            if (!existing) {
                console.warn(`No entry found with chatid: ${chatid}`);
                return;
            }

            existing['isMsgReceived'] = true;

            await store.put(existing);
            await tx.done;
            console.log('Field updated successfully');

        } catch (error) {
            console.error('[updateMessageData] Error:', error);
        }
    };

}



let handlerInstance = Object.freeze(new ChatIDB());

export default handlerInstance;